<template>
  <sweet-modal
    ref="ManageUploadFont"
    width="500px"
    class="modal-upload-font"
    :title="$t('ct-manage-user-font')"
    blocking>

    <template v-if="options.length">
      <ul class="p-0 m-0" style="max-height: 60vh;">
        <li class="d-flex justify-content-between mb-3" v-for="(font_user, index) in options">
          <span>{{ font_user.text }}</span>

          <a class="btn btn-danger px-2"
             data-toggle="tooltip"
             data-placement="right"
             :title="$t('ct-delete')"
             @click.prevent="removeFont(font_user)">
            <i class="svg-icon svgi-delete svgi-light m-0"></i>
          </a>
        </li>
      </ul>
    </template>

    <p v-else>{{$t('ct-manage-user-font-empty')}}</p>

    <button
      slot="button"
      class="btn btn-outline-light"
      @click.prevent="$refs['ManageUploadFont'].close()"
    >{{ $t('ct-close') }}
    </button>
  </sweet-modal>
</template>

<script>
import {SweetModal} from "sweet-modal-vue";
import {remove} from "../../../js/services/editor/userFont";

export default {
  name: "ManageUploadFont",
  components: {
    SweetModal,
  },
  data() {
    return {
      selected: '',
      value: '',
      options: []
    }
  },
  methods: {
    setFont(params) {
      this.options.push(params);
      this.options.sort((a, b) => (a.text > b.text) ? 1 : -1)
    },

    deleteFont(font_id) {
      var options = this.options.filter(font => font.id !== font_id);
      options.sort((a, b) => (a.text > b.text) ? 1 : -1)
      this.options = options;
    },

    removeFont(font) {
      this.selected = font.id;
      this.value = font.value;
      this.$root.$emit('manageFontUploadDelete', this.selected);
    },

    continueDelete() {
      remove(this.selected)
        .then(() => {
          this.$snotify.success(this.$t('ct-success-action'));

          this.deleteFont(this.selected);
          this.$refs['ManageUploadFont'].close();
          this.$root.$emit('deleteFonts', this.value);
          this.$root.$emit('deleteFontsCk', this.value);
        });
    },

    open() {
      this.$refs['ManageUploadFont'].open();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/resources/ManageUploadFont.vue